/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Stripe_DescriptionInputs */

const en_admin_settings_groups_stripe_description = /** @type {(inputs: Admin_Settings_Groups_Stripe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe payment gateway`)
};

/**
* | output |
* | --- |
* | "Stripe payment gateway" |
*
* @param {Admin_Settings_Groups_Stripe_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_stripe_description = /** @type {((inputs?: Admin_Settings_Groups_Stripe_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Stripe_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_stripe_description(inputs)
});
export { admin_settings_groups_stripe_description as "admin.settings.groups.stripe.description" }